import * as React from "react";

function SeriesImageMaker(mode) {
	// console.log("SeriesImageMaker");
	// console.log(mode);
	popupPage();

	function popupPage() {
		window.open("https://imageservice.dat-vps.com/seriesmaker.html", "_blank");
	}

	return <div id="htmlPage"></div>;
}

export default SeriesImageMaker;
